/**
 * 확장 택소노미 태그(entity prefix) 셀 표기 규칙의 단일 소스.
 * 헤더/라벨 셀(th)은 이탤릭+밑줄, 값 셀(td)은 이탤릭 — IXD 편집기와 동일한 규칙.
 */
export const extendedTagClass = (type: "th" | "td") =>
  type === "th" ? "italic underline" : "italic";
